// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__QMDnf","header":"ClearentDisclaimer_header__1ZfCu","inner":"ClearentDisclaimer_inner__1fes0"};